<template>
    <div style="width: 1px; height: 1px; overflow: hidden;" id="pdf-content">
        <div style="padding: 0 1.25cm">
            <table style="width: 100%">
                <tr>
                    <td>
                        <span style="font-size: 28px; font-weight: normal">{{ $t('pdf.calculation-for-dental-treatment') }}</span>
                        <br/>
                        <span style="font-size: 12px;">{{ $t('pdf.created-at') }} {{ currentTime }}</span>
                        <br/>
                        <span style="font-size: 12px;">
                            {{ $t('pdf.open-link') }}<br/><a :href="shortlink" target="_blank" style="text-decoration: none;">{{shortlink}}</a>
                        </span>
                    </td>
                    <td style="text-align: center; width: 120px;">
                        <div style="border-radius: 10px; padding: 5px; background: #444; color: #fff; font-size: 12px; font-weight: 600; vertical-align: top; position:relative;">
                            <div style="text-align: center; background: #fff; padding: 10px 5px; border-radius: 7px;">
                                <qrcode-vue :value="shortlink" :size="90" level="L" renderAs="svg" />
                            </div>
                            <span style="padding-top: 6px; padding-left: 5px; padding-right: 3px; display: inline-block; vertical-align: top;">Scan Me</span><mdi size="18" style="vertical-align: top; margin-top: 4px; color: #fff;">mdiCellphone</mdi>
                        </div>
                    </td>
                </tr>
            </table>

            <br/>


            <pm-treatment-overview-pdf v-for="jaw in ['upper','lower']" :jaw="jaw" :key="jaw + $store.state.currency" />
            <pm-extras-overview-pdf :key="$store.state.currency" />

            <pm-pdf-total :total="fullTotal" :discount="$store.state.simplePlan.discountAmount > 0" />

            <pm-pdf-legal-notice />
        </div>
    </div>
</template>

<script>

import PmOverviewHeaderEmail from "./overview-header-email";
import PmTreatmentOverviewPdf from "./treatment-overview-pdf";
import PmExtrasOverviewPdf from "./extras-overview-pdf";
import PmPdfTotal from "../pdf/treatment-total.vue";
import PmPdfLegalNotice from "../pdf/legal-notice.vue";
import QrcodeVue from 'qrcode.vue';
import { getFullTotal } from "./plan";

export default {
    components: {
        PmOverviewHeaderEmail,
        PmTreatmentOverviewPdf,
        PmExtrasOverviewPdf,
        QrcodeVue,
        PmPdfTotal,
        PmPdfLegalNotice,
    },
    props: {
        animationData: {
            type: Object
        }
    },
    computed: {
        fullTotal() {
            return getFullTotal();
        },
        currentTime() {
            try {
                const t = new Date();
                return new Intl.DateTimeFormat([this.$store.state.language, 'en-US'],  { dateStyle: 'long'}).format(t);
            } catch(error) {
                console.log(event.toLocaleTimeString('ar-EG'));
            }
        },
        animationUrl() {
            let data = {};
            data.language = this.animationData.language;
            data.status = [];
            this.animationData.status.forEach(status => {
               data.status.push({
                   t: status.tooth_id,
                   p: status.state_pid,
               });
            });

            data.steps = [];
            this.animationData.steps.forEach(step => {
                if (!step.animate) return;
               data.steps.push({
                   t: step.tooth_id,
                   p: step.animation_pid || step.state_pid,
                   o: step.state_ordering,
                   tt: step.title_animation || step.title,
               });
            });

            const rootUrl = "https://3dplayer.dev.planmaster.hu/denticalc?data="
            return rootUrl + btoa(encodeURIComponent(JSON.stringify(data)));
        },
    },
    data: () => ({
        shortlink: "",
    }),
    methods: {
        async getAnimationUrl() {
            const url = this.animationUrl;

            await request
                .post("https://denticalcsrvc.planmaster.hu/shortlink")
                    .send({
                        url: this.animationUrl,
                    })
                    .withCredentials(false)
                    .then((resp) => {
                        console.log(resp);
                        this.shortlink = resp.body.shortLink;
                    })
                    .catch((error) => {
                        captureException(error);

                    });

            return true;
        },
    }
}
</script>
